import { InputBuild } from 'components/molecules/InputBuild'
import { AgentResponseDTO } from 'models'
import React, { useEffect, useMemo, useState } from 'react'
import { getAgentsByState } from 'services/agent'
import formatter from 'utils/formatter'
import { AgentCnpjInputProps } from './interfaces'

export const AgentCnpjInput: React.FC<AgentCnpjInputProps> = ({
    id,
    label,
    uf,
    value = '',
    onChange,
    err,
    required,
    placeholder = 'Digite ou selecione um CNPJ'
}) => {
    const [agents, setAgents] = useState<AgentResponseDTO[]>([])

    const normalizedUf = String(uf ?? '')
        .trim()
        .toUpperCase()

    useEffect(() => {
        let active = true

        if (!normalizedUf) {
            setAgents([])
            return () => {
                active = false
            }
        }

        setAgents([])

        getAgentsByState(normalizedUf)
            .then(data => {
                if (active) {
                    setAgents(data)
                }
            })
            .catch(() => {
                if (active) {
                    setAgents([])
                }
            })

        return () => {
            active = false
        }
    }, [normalizedUf])

    const uniqueAgents = useMemo(() => {
        const agentsByCnpj = new Map<string, AgentResponseDTO>()

        agents.forEach(agent => {
            const cnpj = formatter.onlyNumber(agent.cnpj ?? '')

            if (cnpj && !agentsByCnpj.has(cnpj)) {
                agentsByCnpj.set(cnpj, agent)
            }
        })

        return Array.from(agentsByCnpj.values()).sort((first, second) =>
            first.razaoSocial.localeCompare(second.razaoSocial, 'pt-BR')
        )
    }, [agents])

    const listId = `${id}-agents-by-state`

    return (
        <>
            <InputBuild
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                err={err}
                required={required}
                maskReplace="cnpj"
                inputMode="numeric"
                maxLength={18}
                list={listId}
                autoComplete="off"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    onChange(formatter.cnpj(event.target.value))
                }
            />

            <datalist id={listId}>
                {uniqueAgents.map(agent => {
                    const cnpj = formatter.cnpj(agent.cnpj)

                    return (
                        <option
                            key={formatter.onlyNumber(agent.cnpj)}
                            value={cnpj}
                            label={`${agent.razaoSocial} - ${cnpj}`}
                        />
                    )
                })}
            </datalist>
        </>
    )
}
